import script from "./MessageInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./MessageInput.vue?vue&type=script&setup=true&lang=ts"

import "./MessageInput.vue?vue&type=style&index=0&id=bfa955f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bfa955f8"]])

export default __exports__